export const STATISTICS_TYPE_VDS = 'STATISTICS_TYPE_VDS';
export const STATISTICS_TYPE_GHG = 'STATISTICS_TYPE_GHG';
